import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 82 82"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "data-name": "Layer 2" }, [
      _createElementVNode("path", { d: "M41 82a41 41 0 1 1 41-41 41 41 0 0 1-41 41m0-80a39 39 0 1 0 39 39A39.05 39.05 0 0 0 41 2" }),
      _createElementVNode("path", { d: "M59 31.78A14.8 14.8 0 0 1 54.76 33 7.38 7.38 0 0 0 58 28.86a14.5 14.5 0 0 1-4.69 1.79 7.39 7.39 0 0 0-12.77 5.05 7.2 7.2 0 0 0 .19 1.69 21 21 0 0 1-15.23-7.72 7.42 7.42 0 0 0 2.29 9.86 7.3 7.3 0 0 1-3.35-.92v.09a7.38 7.38 0 0 0 5.93 7.24 7.4 7.4 0 0 1-3.33.13 7.38 7.38 0 0 0 6.89 5.13A15 15 0 0 1 23 54.26a21 21 0 0 0 11.32 3.32c13.59 0 21-11.26 21-21v-1a15.1 15.1 0 0 0 3.68-3.8" })
    ], -1)
  ])))
}
export default { render: render }